import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { CardRatingsPage } from '../features/card-ratings/page'

export const cardRatingsRoute = createRoute({
  path: 'card-ratings',
  getParentRoute: () => rootRoute,
  component: CardRatingsPage,
})
